import React, { forwardRef, useId } from 'react';

/**
 * <Checkbox label="Remember me" checked={x} onChange={(v) => ...}/>
 *
 * Bootstrap form-check üzerine kurulu; onChange(checkedBool, event) API'si korunur.
 */
const Checkbox = forwardRef(function Checkbox({
  label,
  hint,
  checked = false,
  onChange,
  disabled = false,
  id: idProp,
  size = 'md',
  className = '',
  style,
  ...rest
}, ref) {
  const uid = useId();
  const id  = idProp || uid;
  const boxSize = size === 'sm' ? 14 : size === 'lg' ? 20 : 16;

  return (
    <div className={`form-check ${className}`} style={style}>
      <input
        ref={ref}
        id={id}
        type="checkbox"
        className="form-check-input"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked, e)}
        style={{ width: boxSize, height: boxSize, marginTop: 0 }}
        {...rest}
      />
      {label && (
        <label htmlFor={id} className="form-check-label" style={{
          fontSize: 'var(--fs-xs)', color: 'var(--text-secondary)',
        }}>
          {label}
          {hint && (
            <span style={{ color: 'var(--text-muted)', marginLeft: 6, fontSize: 'var(--fs-2xs)' }}>
              {hint}
            </span>
          )}
        </label>
      )}
    </div>
  );
});

export default Checkbox;
